module.exports = __webpack_public_path__ + "static/media/slider7.b3991f54.png";